import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';

const InlineSpinner = ({ style }) => <Loader active inline style={style} />;

InlineSpinner.propTypes = {
  style: PropTypes.object,
};

export default InlineSpinner;
